import { render, staticRenderFns } from "./DocFaceLibraryResourceDelete.vue?vue&type=template&id=6ee50448&scoped=true"
import script from "./DocFaceLibraryResourceDelete.vue?vue&type=script&lang=js"
export * from "./DocFaceLibraryResourceDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee50448",
  null
  
)

export default component.exports